export const supportedLanguages = ['en', 'fr', 'de', 'es', 'ja', 'ru', 'pt'] as const;

export function isSupportedLanguage(language?: string): language is SupportedLanguage {
  return supportedLanguages.includes(language as SupportedLanguage);
}

export type SupportedLanguage = typeof supportedLanguages[number];
